import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { LinearProgress } from '@mui/material';
import { todayToUnix } from 'webui/utils/unixtime';
/**
 * Надо вернуть число от 0 до 100 для корректного отображения
 * @param {BilledSim} paid_until до когда оплачена сим-карта
 */
function getPercentPaidUntil(paid_until) {
    if (paid_until == null) {
        return 0;
    }
    const now = todayToUnix();
    if (now > paid_until) {
        return 0;
    }
    const dif_per_month_percent = Math.floor(((paid_until - now) * 100) / (31 * 24 * 60 * 60));
    return dif_per_month_percent > 100 ? 100 : dif_per_month_percent;
}
export function BilledSimStatusLine(props) {
    const { sim } = props;
    if (!sim.paid_until) {
        return null;
    }
    return (_jsx(LinearProgress, { variant: "determinate", value: getPercentPaidUntil(sim.paid_until), color: "primary", sx: {
            width: '100%',
            borderRadius: '21px',
        } }));
}
